import React, { useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  StepConnector,
  stepConnectorClasses,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/system";
import axios from "axios";
import {
  CheckCircle,
  Business,
  AccountBalance,
  VerifiedUser,
  Settings,
  InsertDriveFile,
} from "@mui/icons-material"; // Add icons
import Swal from "sweetalert2"; // Import SweetAlert2
import { useNavigate } from "react-router-dom";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 25,
    left: "calc(-50% + 30px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const steps = [
  "Personal Details",
  "Business Details",
  "Bank Details",
  "Additional Information",
];

const fields = {
  personal: [
    "firstName",
    "middleName",
    "lastName",
    "merchantPhoneNumber",
    "merchantEmailId",
    "userPan",
    "aadhaarNumber",
    "merchantAddress1",
    "merchantState",
    "merchantCityName",
    "merchantDistrictName",
    "merchantPinCode",
  ],
  business: ["companyLegalName", "companyType", "gstinNumber"],
  bank: [
    "merchantCompanyBankAccountNumber",
    "merchantBankIfscCode",
    "merchantBankAccountName",
  ],
  additional: [
    "shopAddress",
    "shopCity",
    "shopDistrict",
    "shopState",
    "shopPincode",
    "shopLatitude",
    "shopLongitude",
    "termsConditionCheck",
  ],
};
const stepIcons = [
  <CheckCircle />,
  <Business />,
  <AccountBalance />,
  <Settings />,
]; // Assign icons to steps
const CustomStepIcon = ({ icon, active, completed }) => {
  const iconStyles = {
    fontSize: "0.1rem", // Larger icon size
    backgroundColor: active ? "#f4a300" : completed ? "#4caf50" : "#eaeaf0", // Green for active, Yellow for completed, Gray for default
    color: "#fff",
    borderRadius: "50%",
    padding: "12px",
    transition: "background-color 0.3s ease, transform 0.3s ease",
    boxShadow: active ? "0px 4px 8px rgba(0, 0, 0, 0.2)" : "none", // Shadow for active state
    transform: active ? "scale(1.2)" : "scale(1)", // Slightly scale up when active
  };

  return <Box sx={iconStyles}>{icon}</Box>;
};
const labels = {
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  merchantPhoneNumber: "Phone Number",
  merchantEmailId: "Email",
  companyLegalName: "Company Name",
  companyType: "Company Type",
  gstinNumber: "GST Number",
  merchantAddress1: "Address",
  merchantState: "State",
  merchantCityName: "City",
  merchantDistrictName: "District",
  merchantPinCode: "Pin Code",
  merchantCompanyBankAccountNumber: "Bank Account Number",
  merchantBankIfscCode: "IFSC Code",
  merchantBankAccountName: "Account Holder Name",
  termsConditionCheck: "Accept Terms & Conditions",
  userPan: "User PAN",
  aadhaarNumber: "Aadhaar Number",
  shopAddress: "Shop Address",
  shopCity: "Shop City",
  shopDistrict: "Shop District",
  shopState: "Shop State",
  shopPincode: "Shop Pincode",
  shopLatitude: "Shop Latitude",
  shopLongitude: "Shop Longitude",
};

const validationSchema = Yup.object().shape({
  // Personal Information
  firstName: Yup.string()
    .required("Required")
    .matches(/^[A-Za-z]+$/, "Only letters are allowed"),
  middleName: Yup.string(),
  lastName: Yup.string()
    .required("Required")
    .matches(/^[A-Za-z]+$/, "Only letters are allowed"),
  merchantPhoneNumber: Yup.string()
    .matches(/^\d{10}$/, 'Enter a valid 10-digit phone number')
    .required('Phone number is required'),
  userPan: Yup.string()
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, 'Enter valid PAN (e.g., ABCDE1234F)')
    .required('PAN is required'),
  aadhaarNumber: Yup.string()
    .matches(/^\d{12}$/, 'Enter valid 12-digit Aadhaar number')
    .required('Aadhaar number is required'),
  merchantEmailId: Yup.string().email("Invalid email").required("Required"),
  merchantAddress1: Yup.string().required("Address is required"),
  merchantState: Yup.mixed()
    .required("State is required"),
  merchantCityName: Yup.string().required("City name is required"),
  merchantDistrictName: Yup.string().required("District name is required"),
  merchantPinCode: Yup.string().required("Pincode is required"),

  // Company Details
  companyLegalName: Yup.string()
    .required("Required")
    .matches(/^[A-Za-z0-9\s]+$/, "Only letters, numbers, and spaces are allowed"),
  companyType: Yup.string().required("Company type is required"),
  gstinNumber: Yup.string()
    .matches(/^[0-9A-Z]{15}$/, "Invalid GSTIN")
    .required("Required"),
  // Bank Details
  merchantCompanyBankAccountNumber: Yup.string()
    .required("Required")
    .matches(/^\d{9,18}$/, "Invalid account number"),
  merchantBankIfscCode: Yup.string()
    .required("Required")
    .matches(/^[A-Za-z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code"),
  merchantBankAccountName: Yup.string()
    .required("Required")
    .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed"),

  // Terms & Conditions
  termsConditionCheck: Yup.boolean()
    .oneOf([true], "You must accept the terms & conditions")
    .required("Required")
});


const MerchantReg = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [states, setStates] = useState([]); // State to store API response
  const [companyTypes, setCompanyTypes] = useState([]); // State for company types
  const [latitude, setLatitude] = useState(0); // State for latitude
  const [longitude, setLongitude] = useState(0); // State for longitude
  const navigate = useNavigate(); // Initialize useNavigate
  const [previewOpen, setPreviewOpen] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    merchantPhoneNumber: "",
    merchantEmailId: "",
    companyLegalName: "",
    companyType: "",
    gstinNumber: "",
    merchantAddress1: "",
    merchantState: 0,
    merchantCityName: "",
    merchantDistrictName: "",
    merchantPinCode: "",
    merchantCompanyBankAccountNumber: "",
    merchantBankIfscCode: "",
    merchantBankAccountName: "",
    termsConditionCheck: false,
    userPan: "",
    aadhaarNumber: "",
    shopAddress: "",
    shopCity: "",
    shopDistrict: "",
    shopState: 0,
    shopPincode: "",
    shopLatitude: 0,
    shopLongitude: 0,
  });

  // Get user's location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          setLatitude(lat);
          setLongitude(lng);
          // Update form data with location
          setFormData((prev) => ({
            ...prev,
            shopLatitude: lat,
            shopLongitude: lng,
          }));
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Failed to get location. Please check your location settings.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }, []);

  // Fetch company types
  useEffect(() => {
    const fetchCompanyTypes = async () => {
      try {
        const token = sessionStorage.getItem("jwtToken");
        const response = await axios.get(
          "https://api.ipaisa.co.in/myapp/auth/cmsData/getCompanyType",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCompanyTypes(response.data.body.data);
      } catch (error) {
        console.error("Error fetching company types:", error);
      }
    };

    fetchCompanyTypes();
  }, []);

  // Fetch states from API
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.get(
          "https://api.ipaisa.co.in/myapp/auth/cmsData/getAllCmsState"
        );
        setStates(response.data.body); // Store API response
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, []);

  // Handle dropdown change
  const handleDropdownChange = (e, setFieldValue) => {
    const { name, value } = e.target;
    setFieldValue(name, value); // Update Formik value
    setFormData((prev) => ({
      ...prev,
      [name]: value, // Update formData state
    }));
  };

  const handleNext = (values) => {
    console.log(values);
    setFormData({ ...formData, ...values });
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "merchantState" || name === "shopState"
          ? Number(value)
          : value,
    }));
  };

  const handleSubmit = async (values, { resetForm }) => {
    // Add logic to convert merchantState and shopState to numbers
    const updatedData = {
      ...values,
      merchantState: Number(values.merchantState),
      shopState: Number(values.shopState),
    };

    setFormData(updatedData);

    console.log("Updated FormData:", updatedData); // Ensure updated values are logged

    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.post(
        "https://api.ipaisa.co.in/myapp/auth/cms/mercahntOnboarding",
        updatedData, // Use updatedData instead of formData
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("API Response:", response.data);

      if (response.data.statusCodeValue === 201) {
        sessionStorage.setItem("cmsMerchantApplyStatus", "True");

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.body.message,
          timer: 3000, // 3 seconds
          showConfirmButton: false, // hide the OK button
          timerProgressBar: true, // optional: shows a nice progress bar
          didClose: () => {
            navigate("/dashboard");
          },
        });
      }
      else if (response.data.statusCodeValue === 500) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response.data.body.message,
        });
        return;
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response.data.body.message,
        });
        return;
      }

      // Reset the form and redirect to the first step
      resetForm();
      setActiveStep(0);
    } catch (error) {
      console.error("Error in API call:", error);

      // Show SweetAlert with error message
      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          error.response?.data?.message ||
          "An error occurred while submitting the form.",
      });
    }
  };

  useEffect(() => {
    console.log("FormData updated:", formData);
  }, [formData]);

  useEffect(() => {
    console.log("FormData updated:", formData);
  }, [formData]);

  const onFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
  };


  return (
    <Formik
      initialValues={{
        ...formData,
        shopLatitude: latitude || "",
        shopLongitude: longitude || "",
      }}
      enableReinitialize={true}
      validationSchema={validationSchema[activeStep]}
      onSubmit={(values, formikHelpers) => {
        if (activeStep === steps.length - 1) {
          handleSubmit(values, formikHelpers); // Pass formikHelpers to handleSubmit
        } else {
          handleNext(values);
          formikHelpers.setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        touched,
        values,
        handleChange,
        setFieldValue,
        validateForm,
        validateField, // ✅ Now available
        handleBlur,
        resetForm,
      }) => {
        // Safely get the current step fields
        const currentStepKey = Object.keys(fields)[activeStep];
        const currentStepFields = fields[currentStepKey] || [];

        return (
          <Grid sx={{ padding: "2rem", marginTop: "4%" }}>
            <Paper sx={{ padding: "2rem", borderRadius: "12px" }}>
              <Typography
                sx={{
                  fontSize: "20px",
                  textDecoration: "underline",
                  marginBottom: "2%",
                  fontWeight: "bold",
                }}
                align="center"
              >
                Merchant Registration
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "red",
                  fontWeight: "500",
                  marginBottom: "1rem",
                  textAlign: "center",
                }}
              >
                Add details only according to Aadhaar Card
              </Typography>
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                connector={<QontoConnector />}
              >
                {steps.map((label, index) => (
                  <Step key={label}>
                    <StepLabel
                      icon={
                        <CustomStepIcon
                          icon={stepIcons[index]}
                          active={activeStep === index}
                          completed={activeStep > index}
                        />
                      }
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>

              <Box
                mt={2}
                p={3}
                border={1}
                borderRadius={2}
                borderColor="grey.300"
              >
                <Grid container spacing={2}>
                  {currentStepFields.map((field) => (
                    <Grid item xs={12} sm={6} md={6} key={field}>
                      {["merchantState", "shopState"].includes(field) ? (
                        <FormControl fullWidth>
                          <Autocomplete
                            options={states}
                            getOptionLabel={(option) => option.state}
                            value={
                              states.find((state) => state.stateId === values[field]) || null
                            }
                            onChange={(e, newValue) => {
                              setFieldValue(field, newValue ? newValue.stateId : "");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={labels[field]}
                                error={Boolean(errors[field] && touched[field])}
                                helperText={
                                  errors[field] && touched[field] ? errors[field] : ""
                                }
                              />
                            )}
                          />
                        </FormControl>
                      ) : field === "companyType" ? (
                        <FormControl fullWidth>
                          <Autocomplete
                            options={companyTypes}
                            getOptionLabel={(option) => option.mccDescription}
                            value={
                              companyTypes.find((type) => type.mccCode === values[field]) ||
                              null
                            }
                            onChange={(e, newValue) => {
                              setFieldValue(field, newValue ? newValue.mccCode : "");
                              validateField(field);
                            }}
                            onBlur={(e) => {
                              handleBlur(e);
                              validateField(field);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={labels[field]}
                                error={Boolean(errors[field] && touched[field])}
                                helperText={
                                  errors[field] && touched[field] ? errors[field] : ""
                                }
                              />
                            )}
                          />
                        </FormControl>
                      ) : typeof values[field] === "boolean" ? (
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field]}
                              onChange={() => {
                                setFieldValue(field, !values[field]);
                                validateField(field);
                              }}
                              onBlur={(e) => {
                                handleBlur(e);
                                validateField(field);
                              }}
                            />
                          }
                          label={labels[field]}
                        />
                      )  : (
                        <TextField
                          fullWidth
                          label={labels[field]}
                          name={field}
                          value={values[field]}
                          onChange={(e) => {
                            let newValue = e.target.value;

                            if (["merchantPhoneNumber", "aadhaarNumber"].includes(field)) {
                              newValue = newValue.replace(/\D/g, "");
                            }

                            if (field === "merchantPhoneNumber") {
                              newValue = newValue.slice(0, 10);
                            }
                            if (field === "aadhaarNumber") {
                              newValue = newValue.slice(0, 12);
                            }

                            if (field === "userPan") {
                              newValue = newValue.toUpperCase();
                            }

                            setFieldValue(field, newValue);
                            validateField(field);
                          }}
                          onBlur={(e) => {
                            handleBlur(e);
                            validateField(field);
                          }}
                          variant="outlined"
                          inputProps={{
                            maxLength:
                              field === "merchantPhoneNumber"
                                ? 10
                                : field === "aadhaarNumber"
                                  ? 12
                                  : undefined,
                            inputMode: ["merchantPhoneNumber", "aadhaarNumber"].includes(field)
                              ? "numeric"
                              : "text",
                          }}
                          error={Boolean(errors[field] && touched[field])}
                          helperText={
                            errors[field] && touched[field] ? errors[field] : ""
                          }
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>

              </Box>

              <Box mt={2} display="flex" justifyContent="space-between">
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  Back
                </Button>
                {activeStep === steps.length - 1 && (
                  <Button
                    variant="outlined"
                    color="info"
                    onClick={() => setPreviewOpen(true)}
                  >
                    Preview
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  type={activeStep === steps.length - 1 ? "submit" : "button"}
                  onClick={async () => {
                    // Validate the form before proceeding
                    const errors = await validateForm();
                    if (Object.keys(errors).length === 0) {
                      if (activeStep === steps.length - 1) {
                        // Submit the form
                        handleSubmit(values, { resetForm });
                      } else {
                        // Move to the next step
                        handleNext(values);
                      }
                    }
                  }}
                >
                  {activeStep === steps.length - 1 ? "Submit" : "Next"}
                </Button>
              </Box>
            </Paper>
            <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="md" fullWidth>
              <DialogTitle>Preview Merchant Details</DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  {Object.keys(values).map((key) => (
                    <Grid item xs={12} sm={6} key={key}>
                      <Typography variant="subtitle2" color="textSecondary">
                        {labels[key] || key}
                      </Typography>

                      {values[key] instanceof File ? (
                        values[key].type === "application/pdf" ? (
                          <iframe
                            src={URL.createObjectURL(values[key])}
                            title={key}
                            width="100%"
                            height="200px"
                            style={{ border: "none" }}
                          />
                        ) : (
                          <img
                            src={URL.createObjectURL(values[key])}
                            alt={key}
                            style={{ maxWidth: "100%", maxHeight: 200 }}
                          />
                        )
                      ) : (
                        <Typography variant="body1" sx={{ wordBreak: "break-word" }}>
                          {typeof values[key] === "boolean"
                            ? values[key] ? "Yes" : "No"
                            : values[key] !== null && typeof values[key] === "object"
                              ? JSON.stringify(values[key])
                              : values[key]}
                        </Typography>
                      )}

                    </Grid>
                  ))}
                </Grid>

              </DialogContent>
              <DialogActions>
                <Button onClick={() => setPreviewOpen(false)} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>

          </Grid>
        );
      }}
    </Formik>
  );
};

export default MerchantReg;
